import { connect } from 'react-redux'
import { createSubscription_action, toggleCheckoutModal_action, toggleCreateItemsPopup_action, toggleOnboardingPlansPopup_action, toggleSubscriptionSuccessModal_action } from 'store/actions'
import { getCard_api, getPricePlans_api, getCompanyByUUID_api } from 'store/apis'
import { useCallback, useEffect, useState } from 'react'
import { Modal, ModalBody } from 'reactstrap'
import { checkIsOnGracePeriod, consoleLog, getDiscountedPrice, handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { GracePeriodDiscount, KlutchPricingPlans, PlanSelector, PriceLabel } from './styles'
import ReactSwitch from 'react-switch'
import { colors } from 'modules/app/styles'
import { ReactComponent as SuccessIcon } from 'assets/images/icons/success.svg'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ReactComponent as SubscriptionSuccessIllustration } from 'assets/images/SubscriptionSuccess.svg'
import { CustomButton } from 'modules/auth/styles'
import { PageLoader } from 'utils/storageUtils'
import CardForm from './CardForm'
import Checkout from './Checkout'
import { history } from 'store/store'

const OnboardingPlansModal = (props) => {
  const { company, isOnGracePeriod, subscription, free_items_limit } = props

  const [_company, set_company] = useState({ members: [] })
  const [is_loading, set_is_loading] = useState(true)
  const [_active_company, set_active_company] = useState({})
  const [card, set_card] = useState({})

  // Subscriptions
  const [yearly, set_yearly] = useState({})
  const [monthly, set_monthly] = useState({})
  const [plan_selected, set_plan_selected] = useState({})
  const [active_users, set_active_users] = useState([])

  useEffect(() => {
    history.push('/')
  }, [])

  // SET ACTIVE USERS
  useEffect(() => {
    set_active_users(_company.members.filter((m) => m.is_active && m.invite_status !== 'invited'))
  }, [_company.members])

  const get_company_and_plans = useCallback(async () => {
    try {
      const result = await getCompanyByUUID_api(company.uuid)
      set_company(result)

      const { data } = await getPricePlans_api()
      const _monthly = data.filter((plan) => plan.active && plan.interval === 'month')[0]
      const _yearly = data.filter((plan) => plan.active && plan.interval === 'year')[0]
      let _plan_selected = _monthly
      set_yearly(_yearly)
      set_monthly(_monthly)
      set_plan_selected(_plan_selected)
    } catch (error) {
      handleApiError(error)
    }
    set_is_loading(false)
  }, [company.uuid])

  // Payment method
  const getCard = async () => {
    try {
      set_card({})
      const data = await getCard_api()
      set_card(data)
    } catch (error) {
      consoleLog(error)
    }
  }

  // Subscription
  const startSubscription = async () => {
    try {
      const data = {
        plan: plan_selected.interval
      }
      await props.createSubscription(data)
      props.toggleSubscriptionSuccessModal(true)
      setTimeout(() => {
        props.toggleSubscriptionSuccessModal(false)
        props.toggleOnboardingPlansPopup(false)
        props.toggleCreateItemsPopup(true)
      }, 2000)
    } catch (error) {
      handleApiError(error)
    }
  }

  useEffect(() => {
    if (!_active_company.id && company.id) {
      set_active_company(company)
      get_company_and_plans()
      getCard()
    }
  }, [company, _active_company, get_company_and_plans])

  return (
    <>
      <Modal isOpen centered size='lg'>
        <ModalBody className='p-0'>
          <KlutchPricingPlans>
            <PlanSelector className='border-0 p-5 order-1 order-md-0'>
              <div className='plan-title mt-0'>Free</div>
              <div className='text-center'>Get started with Klutch for free and enjoy its helpful tools to jumpstart your knowledge base.</div>
              <div className='plan-amount lg mb-2'>$0</div>
              <div className='text-center font-weight-600 mb-3 text-capitalize'>Per Month</div>
              <div className='mb-5' style={{ height: 24 }}></div>
              <ul className='plan-specs mb-5'>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Up to {free_items_limit} items</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>10 AI responses</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Response shortcuts</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Up to 2 GB storage</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Unlimited members</span>
                </li>
              </ul>

              {!is_loading && (
                <CustomButton
                  className='black outlined mt-auto'
                  style={{ padding: '14px 36px', marginTop: 65 }}
                  onClick={() => {
                    logAmplitudeEvent('step4 free')
                    props.toggleOnboardingPlansPopup(false)
                    props.toggleCreateItemsPopup(true)
                  }}>
                  Continue as Free
                </CustomButton>
              )}
            </PlanSelector>

            <PlanSelector className='p-5'>
              {checkIsOnGracePeriod(isOnGracePeriod, subscription) && (
                <GracePeriodDiscount>
                  Upgrade before July 1st and enjoy our
                  <br />
                  discounted early bird pricing
                </GracePeriodDiscount>
              )}
              <div className='plan-title mt-0'>PRO</div>
              <div className='text-center'>
                Let your growing team be up to date with one
                <br />
                collective knowledge base. Anytime, anywhere.
              </div>

              {is_loading && <PageLoader />}
              {!is_loading && (
                <>
                  <div className='plan-amount lg mb-2'>
                    {checkIsOnGracePeriod(isOnGracePeriod, subscription) && (
                      <>
                        {/* <div className='earlybird'>20% earlybird discount</div> */}
                        <div className='text-center'>
                          <span className='strike-through mr-3'>${getDiscountedPrice(plan_selected, false, subscription)}</span>
                          <span>${getDiscountedPrice(plan_selected, isOnGracePeriod, subscription)}</span>
                        </div>
                      </>
                    )}
                    {!checkIsOnGracePeriod(isOnGracePeriod, subscription) && (
                      <>
                        <span>${getDiscountedPrice(plan_selected, false, subscription)}</span>
                      </>
                    )}
                  </div>
                  <div className='text-center font-weight-600 mb-3 text-capitalize'>Per User, Per {plan_selected.interval}</div>
                  <div className='mb-5 d-flex align-items-center justify-content-center'>
                    <PriceLabel className={`text-right ${plan_selected.interval === 'month' ? 'active' : ''}`} onClick={() => set_plan_selected(monthly)}>
                      Monthly
                    </PriceLabel>
                    <ReactSwitch
                      id='pricing_plan'
                      onChange={(status) => {
                        set_plan_selected(status ? yearly : monthly)
                      }}
                      checked={plan_selected.interval === 'year'}
                      className={`reactSwitch mx-2 ${plan_selected.interval === 'year' ? 'on' : 'off'}`}
                      offColor='#fff'
                      onColor={colors['main-blue']}
                      offHandleColor={colors['light-blue-300']}
                      onHandleColor='#fff'
                      width={48}
                      height={24}
                      handleDiameter={18}
                      uncheckedIcon={false}
                      checkedIcon={false}
                    />
                    <PriceLabel className={plan_selected.interval === 'year' ? 'active' : ''} onClick={() => set_plan_selected(yearly)}>
                      Yearly <small>(save 20%)</small>
                    </PriceLabel>
                  </div>
                </>
              )}

              <ul className='plan-specs  mb-5'>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Unlimited items</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Unlimited AI responses</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Response shortcuts</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>100GB team storage</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Unlimited members</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>External sharing</span>
                </li>
                <li className='d-flex align-items-center'>
                  <SuccessIcon />
                  <span>Premium support</span>
                </li>
              </ul>
              {!is_loading && (
                <CustomButton
                  className='black mt-auto'
                  style={{ padding: '14px 36px', marginTop: 65 }}
                  disabled={props.isSubmittingSubscription || props.isSubmittingCard}
                  onClick={() => props.toggleCheckoutModal(true, true)}>
                  Subscribe to PRO {plan_selected.interval === 'month' ? 'Monthly' : 'Annually'}
                </CustomButton>
              )}
            </PlanSelector>
          </KlutchPricingPlans>
        </ModalBody>
      </Modal>

      {/* ADD CARD */}
      {props.showCardModal && <CardForm card={card} plan_selected={plan_selected} showCreateItemPopup={true} />}

      {props.showCheckoutModal && (
        <Checkout
          set_plan_selected={set_plan_selected}
          plan_selected={plan_selected}
          subscription={subscription}
          monthly={monthly}
          yearly={yearly}
          active_users={active_users}
          get_company={props.get_company}
          card={card}
          startSubscription={startSubscription}
        />
      )}

      {props.showSubscriptionSuccessModal && (
        <Modal size='sm' isOpen={true} centered fade={false} toggle={() => props.toggleSubscriptionSuccessModal(false)}>
          <ModalBody>
            <a
              href='/'
              className='modal-close'
              onClick={(e) => {
                e.preventDefault()
                props.toggleSubscriptionSuccessModal(false)
              }}>
              <CloseIcon />
            </a>
            <div className='d-flex flex-column align-items-center justify-content-center mb-5'>
              <SubscriptionSuccessIllustration />
              <div className='font-weight-600' style={{ fontSize: 24 }}>
                Welcome to PRO 🎉
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  company: state.company.company,
  free_items_limit: state.company.company.free_items_limit,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  subscription: state.subscription.subscription,
  isSubmittingSubscription: state.subscription.isSubmittingSubscription,
  isSubmittingCard: state.subscription.isSubmittingCard,
  showCardModal: state.subscription.showCardModal,
  showCheckoutModal: state.subscription.showCheckoutModal,
  showSubscriptionSuccessModal: state.subscription.showSubscriptionSuccessModal
})
const mapDispatchToProps = (dispatch) => ({
  createSubscription: (data) => new Promise((resolve, reject) => dispatch(createSubscription_action(data, resolve, reject))),
  toggleOnboardingPlansPopup: (status) => dispatch(toggleOnboardingPlansPopup_action(status)),
  toggleCreateItemsPopup: (status) => dispatch(toggleCreateItemsPopup_action(status)),
  toggleCheckoutModal: (value, isUpgradeStep4) => dispatch(toggleCheckoutModal_action(value, isUpgradeStep4)),
  toggleSubscriptionSuccessModal: (value) => dispatch(toggleSubscriptionSuccessModal_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPlansModal)
